<template>
	<div class="wrap">
		<div class="tool" id="homePage">
			<div class="logo">
				<img src="http://www.100liy.com/read/img/llogin.png">
			</div>
			<div class="logo-name">
				天上白玉京<span>V1.0</span>
			</div>
			<div class="tool-items">
				<label v-for="item in type" :class="selectedType==item.id?'cked':''">
					<input v-model="selectedType" type="radio" name="type" :value="item.id">{{item.name}}
				</label>
			</div>
			<div class="tool-items">
				<label v-for="item in sex" :class="selectedSex==item.id?'cked':''">
					<input v-model="selectedSex" type="radio" name="sex" :value="item.id">{{item.name}}
				</label>
			</div>
			<div class="tool-item">
				<select v-model="selectedYear" @change="clickYear">
					<option v-for="item in year" :key="item.id" :value="item.id">{{item.name}}</option>
				</select>
			</div>
			<div class="tool-item">
				<select v-model="selectedMonth">
					<option v-for="item in month" :key="item.id" :value="item.id">{{item.name}}</option>
				</select>
				<select v-model="selectedRun" v-if="isRun&&selectedType==2">
					<option v-for="item in run" :key="item.id" :value="item.id">{{item.name}}</option>
				</select>
			</div>
			<div class="tool-item">
				<select v-model="selectedDay">
					<option v-for="item in day" :key="item.id" :value="item.id">{{item.name}}</option>
				</select>
			</div>
			<div class="tool-item">
				<select v-model="selectedTime">
					<option v-for="(item,index) in times" :key="item.id" :value="index">{{item}}</option>
				</select>
			</div>
			<div class="tool-item">
				<button id="pc" @click="begin">命元推演</button>
				<button id="mobile" @click="begin2">命元推演</button>
			</div>
			<div class="tool-zs">
				仅供娱乐，并非宿命定论。<br>
				祸福皆由己造，切勿迷信。
			</div>
		</div>
		<div class="cont" id="page">
			<baseInfo :baseInfo="baseInfos"></baseInfo>
			<bazipai :paipan="baseInfos"></bazipai>
			<wuxing :wuxing="baseInfos"></wuxing>
			<geju :geju="baseInfos"></geju>
			<shishen :shishen="baseInfos"></shishen>
			<sixiang :sixiang="baseInfos"></sixiang>
			<liuqin :liuqin="baseInfos"></liuqin>
			<liunian :liunian="baseInfos"></liunian>
			<div class="mobile-gn">
				<div @click="rpbegin">重新推演</div>
				<div @click="more">更多功能</div>
			</div>
		</div>
		<div class="tips" id="morenav">
			<navRight></navRight>
		</div>
	</div>
</template>

<script>
	import baseInfo from '@/page/base'
	import bazipai from '@/page/bazipai'
	import wuxing from '@/page/wuxing'
	import geju from '@/page/geju'
	import shishen from '@/page/shishen'
	import sixiang from '@/page/sixiang'
	import liuqin from '@/page/liuqin'
	import liunian from '@/page/liunian'
	import navRight from '@/page/nav'
	export default {
		components: {
			'baseInfo': baseInfo,
			'bazipai': bazipai,
			'wuxing': wuxing,
			'geju': geju,
			'shishen': shishen,
			'sixiang': sixiang,
			'liuqin': liuqin,
			'liunian': liunian,
			'navRight':navRight
		},
		data() {
			return {
				type: [{
					id: 1,
					'name': '公历',
				}, {
					id: 2,
					'name': '农历',
				}],
				sex: [{
					id: 1,
					'name': '男'
				}, {
					id: 2,
					'name': '女'
				}],
				year: [],
				month: [],
				day: [],
				times: [],
				run: [{
					id: 1,
					'name': '闰月（否）'
				}, {
					id: 2,
					'name': '闰月（是）'
				}],
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				selectedType: 1,
				selectedSex: 2,
				selectedYear: new Date().getFullYear(),
				selectedMonth: new Date().getMonth()+1,
				selectedRun: 1,
				selectedDay: new Date().getDate(),
				selectedTime: 7,
				baseInfos: '',
				isRun:false
			}
		},
		methods: {
			more(){
				document.getElementById('page').style.display = 'none';
				document.getElementById('morenav').style.display = 'block';
			},
			rpbegin(){
				document.getElementById('homePage').style.left = '0';
				document.getElementById('page').style.display = 'none';
			},
			begin2(){
				this.begin();
				document.getElementById('homePage').style.left = '-100%';
				document.getElementById('page').style.display = 'block';
			},
			clickYear(){
				let year = this.selectedYear;
				if (this.selectedType == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, 3, 3, 3, 0, 0);
					let solar = lunar.getSolar();
					this.isRun = solar.isLeapYear();
				} else {
					let solar = Solar.fromYmdHms(year, 3, 3, 3, 0, 0);
					let lunar = solar.getLunar();
					this.isRun = solar.isLeapYear();
				}
			},
			begin() {
				let type = this.selectedType;
				let sex = this.selectedSex;
				let year = this.selectedYear;
				let month = this.selectedMonth;
				let day = this.selectedDay;
				let time = this.selectedTime;
				let chen = [23,2,4,6,8,10,12,14,16,18,20,22];
				let times = chen[time];
				
				if(this.isRun&&this.selectedRun){
					
				}
				this.baseInfos = {
					type: type,
					sex: sex,
					year: year,
					month: month,
					day: day,
					time: time
				};
			},
			getData() {
				let currYear = new Date().getFullYear();
				for (let i = currYear; i >= 1900; i--) {
					let obj = {
						'id': i,
						'name': i + '年'
					}
					this.year.push(obj)
				}
				for (let i = 1; i <= 12; i++) {
					let obj = {
						'id': i,
						'name': i + '月'
					}
					this.month.push(obj)
				}
				for (let i = 1; i <= 31; i++) {
					let obj = {
						'id': i,
						'name': i + '日'
					}
					this.day.push(obj)
				}
			},
		},
		created() {
			this.getData();
		}
	}
</script>

<style>
	.mobile-gn{
		display: none;
		margin: 0 7%;
	}
	.mobile-gn div{
		width: 46%;
		margin: 15px 2%;
		font-size: 13px;
		text-align: center;
		line-height: 40px;
		border: 1px solid #CC2535;
		color: #CC2535;
		box-sizing: border-box;
		border-radius: 10px;
		background-color: #fff;
	}
	.tool-zs{
		font-size: 12px;
		color: #999;
		padding-top: 30px;
		line-height: 24px;
		text-align: center;
	}
	.logo-name{
		text-align: center;
		padding: 25px 0 40px 0;
		font-size: 17px;
	}
	.logo-name span{
		position: relative;
		top: -2px;
		background-color: #CC2535;
		font-size: 12px;
		color: #fff;
		margin-left: 5px;
		padding: 3px 5px;
		border-radius: 10px;
	}
	.logo{
		width: 60px;
		margin: auto;
	}
	.logo img{
		display: block;
		width: 100%;
	}
	.tool-items {
		position: relative;
		width: 100%;
		height: 40px;
		background: #fff;
		border-radius: 10px;
		display: flex;
		padding: 0;
		overflow: hidden;
		margin-bottom: 15px;
		font-size: 15px;
	}

	.tool-items input {
		display: none;
	}

	.tool-items label {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 15px;
		color: #666;
		z-index: 2;
		margin: 3px;
		border-radius: 8px;
	}

	.tool-items .cked {
		background-color: #28B95E;
		color: #fff;
		line-height: 34px;
	}


	.tool-item button {
		margin-top: 20px;
		width: 100%;
		font-size: 15px;
		padding: 5px 0;
		line-height: 30px;
		border-radius: 5px;
		border: 0;
		background-color: #cc2535;
		color: #fff;
	}

	.tips {
		flex: 1;
		background-color: rgba(255,255,255,.2);
	}

	.tool-item {
		display: flex;
	}

	.tool-item select {
		appearance: none;
		-webkit-appearance: none;
		width: 100%;
		height: 38px;
		padding: 0 15px;
		font-size: 15px;
		border: 1px solid #fff;
		border-radius: 5px;
		background-color: #ffffff;
		background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-position: right 10px center;
		color: #333;
		cursor: pointer;
		transition: all 0.2s ease;
	}

	.tool-item select:hover {
		border-color: #28B95E;
		box-shadow: 0 2px 6px rgba(40, 185, 94, 0.1);
	}

	.tool-item select:focus {
		outline: none;
		border-color: #28B95E;
		box-shadow: 0 0 0 3px rgba(40, 185, 94, 0.15);
	}

	.tool-item select option {
		padding: 10px;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/page/index.vue